import React from "react";
import { BadgeCheck } from "lucide-react";

export function VerifiedBadge({ verified, className = "w-4 h-4" }) {
  if (!verified) return null;
  return (
    <span
      title="Verified Wolf"
      aria-label="Verified Wolf"
      data-testid="verified-badge"
      className="inline-flex items-center shrink-0"
    >
      <BadgeCheck className={`text-white fill-sky-500 ${className}`} />
    </span>
  );
}
